import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import { units } from '../theme/units';
const useStyles = makeStyles()(() => ({
    extraSmallIcon: {
        minWidth: units.rem(0.5),
        fontSize: units.rem(0.5),
    },
    smallIcon: {
        minWidth: units.rem(2.5),
        fontSize: units.rem(1.25),
    },
}));
const ListItemIcon = ({ iconSize = 'large', className, ...rest }) => {
    const { classes, cx } = useStyles();
    const sizeClass = React.useMemo(() => {
        const sizes = {
            extraSmall: classes.extraSmallIcon,
            small: classes.smallIcon,
        };
        return sizes[iconSize];
    }, [classes.extraSmallIcon, classes.smallIcon, iconSize]);
    return _jsx(MuiListItemIcon, { ...rest, className: cx(className, sizeClass) });
};
export { ListItemIcon };
